import { render } from "./grid-element.vue?vue&type=template&id=c0daa03e&scoped=true"
import script from "./grid-element.vue?vue&type=script&lang=ts"
export * from "./grid-element.vue?vue&type=script&lang=ts"

import "./grid-element.vue?vue&type=style&index=0&id=c0daa03e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c0daa03e"

export default script